import { Component, Input } from '@angular/core';
import { Product } from '../../models/response';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-product-chat-description',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './product-chat-description.component.html',
  styleUrl: './product-chat-description.component.scss'
})
export class ProductChatDescriptionComponent {

  @Input() selectedProduct:Product  = {};

}
